import { NgModule } from '@angular/core';
import {Routes,RouterModule} from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LoggedoutComponent } from './loggedout/loggedout.component';

const loginroutes: Routes = [


    { path: '', redirectTo: '/login', pathMatch: 'full' },
    {path: '', component: LoginComponent},
    {path: 'login', component: LoginComponent},
    {path: 'loggedout', component: LoggedoutComponent},
    
    ]
 @NgModule({
    imports: [
        RouterModule.forChild(loginroutes)
    ], 
    exports: [RouterModule]
    }
  )
 export class AuthRoutingModule {
 

 } 